import React, { useState } from 'react';

const PaperCard = ({
  title,
  authors = '',
  abstract,
  onSkip,
  onVote,
  onAdd,
  remainingVotes,
  hasVoted,
  showAddButton,
  showInstructions,
  isSwipingRight,
  isSwipingLeft,
  date,
  time_start,
  time_end,
  location,
}) => {
  const [isAbstractVisible, setIsAbstractVisible] = useState(false);

  const toggleAbstractVisibility = () => {
    setIsAbstractVisible(!isAbstractVisible);
  };

  const cardClass = `card ${isSwipingRight ? 'swipe-right' : ''} ${isSwipingLeft ? 'swipe-left' : ''}`;

  const formattedDate = new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });

  const formattedTime = `${time_start} - ${time_end}`;

  return (
    <div className={cardClass}>
      {hasVoted && (
        <div className="voted-indicator">
          <i className="fas fa-check-circle"></i>
        </div>
      )}
      <h2>{title}</h2>
      <p className="authors">{authors || 'No authors listed'}</p>
      <div className="event-details">
        <div className="event-time">
          <div>{formattedDate}</div>
          <div>{formattedTime}</div>
        </div>
        <div className="event-location">
          {location}
        </div>
      </div>
      <div className={`abstract-container ${isAbstractVisible ? 'visible' : ''}`}>
        <p className="abstract">{abstract || 'No abstract available'}</p>
      </div>
      <button onClick={toggleAbstractVisibility} className="toggle-abstract">
        {isAbstractVisible ? 'Hide Abstract' : 'Show Abstract'}
      </button>
      <div className="separator"></div>
      <div className="buttons">
        <div className="button-with-instruction">
          <button className="skip" onClick={onSkip}><i className="fas fa-times"></i></button>
          {showInstructions && <div className="instruction-text instruction-skip">Skip</div>}
        </div>
        <div className="button-with-instruction">
          {showAddButton && (
            <button className="add" onClick={onAdd}><i className="fas fa-plus"></i></button>
          )}
          {showInstructions && showAddButton && <div className="instruction-text instruction-add">Add to agenda</div>}
        </div>
      </div>
      {showInstructions && (
        <>
          <div className="final-instruction">
            <p>The recommender will learn your preferences based on your actions</p>
          </div>
          <div className="instructions-container">
            <div className="instruction-item">
              <img src="/images/add.png" alt="Add to Agenda" style={{ width: '25px', height: '25px', verticalAlign: 'middle' }} />
              <span>Add abstract to Agenda </span>
              <i className="agenda-icon far fa-calendar-alt" style={{ fontSize: '1.25em' }}></i>
            </div>
            <div className="instruction-item">
              <img src="/images/skip.png" alt="Skip" style={{ width: '25px', height: '25px', verticalAlign: 'middle' }} />
              <span>Get next recommendation</span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PaperCard;
